"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextWrapper = exports.SideNavigationCard = exports.ImageWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _coreInteraction = _interopRequireDefault(require("@vfuk/core-interaction"));
var _coreImage = require("@vfuk/core-image");
var _coreMixins = require("@vfuk/core-mixins");
var _SideNavigationCard = _interopRequireDefault(require("../themes/SideNavigationCard.theme"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var SideNavigationCard = (0, _styledComponents["default"])(_coreInteraction["default"]).withConfig({
  displayName: "SideNavigationCardstyle__SideNavigationCard",
  componentId: "sc-1nqvxcv-0"
})(function (props) {
  var localAppearance = (0, _SideNavigationCard["default"])(props.theme).appearance[props.appearance];
  var localSize = (0, _SideNavigationCard["default"])(props.theme).size;
  return (0, _styledComponents.css)(["display:flex;background:", ";border-radius:0 ", " ", " 0;width:auto;", " ", " height:", "px;", " ", ""], localAppearance.backgroundColor, props.theme.border.radius[2], props.theme.border.radius[2], (0, _coreMixins.spacing)('margin-left', -6), (0, _coreMixins.elevation)(true), localSize.sm.height, _coreMixins.respondTo.md((0, _styledComponents.css)(["height:", "px;"], localSize.md.height)), _coreMixins.respondTo.lg((0, _styledComponents.css)(["height:", "px;"], localSize.lg.height)));
});
exports.SideNavigationCard = SideNavigationCard;
var TextWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SideNavigationCardstyle__TextWrapper",
  componentId: "sc-1nqvxcv-1"
})(function (props) {
  var localSize = (0, _SideNavigationCard["default"])(props.theme).size;
  return (0, _styledComponents.css)(["display:flex;align-items:center;", " width:calc(100% - ", "px);", " ", ""], (0, _coreMixins.advancedSpacing)('padding', [6, 4, 6, 6]), localSize.sm.height, _coreMixins.respondTo.md((0, _styledComponents.css)(["width:calc(100% - ", "px);"], localSize.md.height)), _coreMixins.respondTo.lg((0, _styledComponents.css)(["width:calc(100% - ", "px);"], localSize.lg.height)));
});
exports.TextWrapper = TextWrapper;
var ImageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SideNavigationCardstyle__ImageWrapper",
  componentId: "sc-1nqvxcv-2"
})(function (props) {
  return (0, _styledComponents.css)(["", "{height:100%;border-radius:0 ", " ", " 0;object-fit:cover;}"], _coreImage.ImageStyles.Image, props.theme.border.radius[2], props.theme.border.radius[2]);
});
exports.ImageWrapper = ImageWrapper;